import { ListStateHandler } from "./ListStateHandler";

const reducer = (listingActionPrefix, itemActionPrefix, {initialState, customReducer, listItemsPath, itemUpdateDirtiesList} = {}) => {
	const handler = new ListStateHandler({
		initialState,
		actionPrefix: listingActionPrefix,
		itemActionPrefix,
		listItemsPath,
		itemUpdateDirtiesList,
	});

	return {
		...handler.setupActions(),
		...customReducer,
	};
};

Object.defineProperty(reducer, "initialState", {value: ListStateHandler.model.defaultInitialState});

export default reducer;